(function () {
  var protectedSelector = [
    'img',
    'picture',
    'svg',
    '.product-media',
    '.product__media',
    '.media',
    '.card__media',
    '.collection-card',
    '.dogdad-hero',
    '.dogdad-category-card',
    '.background-image-container',
    '[style*="background-image"]'
  ].join(',');

  function isProtectedMedia(target) {
    if (!target || !target.closest) return false;
    var element = target.closest(protectedSelector);
    if (!element) return false;

    if (element.matches('img, picture, svg, .product-media, .product__media, .media, .card__media, .collection-card, .dogdad-hero, .dogdad-category-card, .background-image-container, [style*="background-image"]')) {
      return true;
    }

    var background = window.getComputedStyle(element).backgroundImage;
    return background && background !== 'none';
  }

  function protectImages(root) {
    (root || document).querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
      img.setAttribute('oncontextmenu', 'return false;');
      img.style.webkitUserDrag = 'none';
    });
  }

  document.addEventListener('contextmenu', function (event) {
    if (isProtectedMedia(event.target)) {
      event.preventDefault();
    }
  }, true);

  document.addEventListener('dragstart', function (event) {
    if (isProtectedMedia(event.target)) {
      event.preventDefault();
    }
  }, true);

  document.addEventListener('selectstart', function (event) {
    if (isProtectedMedia(event.target)) {
      event.preventDefault();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    var key = (event.key || '').toLowerCase();
    if ((event.ctrlKey || event.metaKey) && (key === 's' || key === 'u')) {
      event.preventDefault();
    }
  });

  protectImages(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) protectImages(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();